package com.appsyde.shared.modules.ticket.domain.model

/**
 * Pièce jointe prête à envoyer (côté domaine).
 * Rempli par la couche présentation à partir des fichiers sélectionnés (UI lit le fichier, pas le VM).
 */
data class OutboundAttachmentForSend(
    val filename: String,
    val mimeType: String,
    val contentBase64: String,
    val sizeBytes: Long,
    val sha256: String? = null
)
